import {Glob as G} from "../../libs/Glob.mjs";
import AutoRadioFields from "./AutoRadioFields.mjs";

const AutoYNField = class extends AutoRadioFields {
	constructor(props) {
		super(props);
		this.state.options = [
			{ value: 'Y', label: G.label('Yes') },
			{ value: 'N', label: G.label('No') }
		];
	}
}

export default AutoYNField;